<template>
  <v-container py-3 fluid class="nx-content-wizard-body">
    <v-layout wrap fill-height justify-center>
      <v-flex class="xs12 sm10 md8">
        <form class="message-form">
          <h2 class="nx-form-legend mb-1 mt-2"
              v-html="$t('message.content.live.configMessage')"
          ></h2>
          <v-toolbar justify-space-between color="transparent" flat dense
                     class="message-form__toolbar elevation-0">
            <v-flex><h4>{{ $t('message.content.live.publish') }}</h4></v-flex>
            <v-flex shrink>
              <nx-form-switch
                name="published"
                :value="messageThatIsBeingEdited.published"
              ></nx-form-switch>
            </v-flex>
          </v-toolbar>
          <nx-form-date-time-picker
            name="publicationDate"
            :maxDate="maxDate"
            :label="$t('message.form.fields.publicationDate')"
            :value="messageThatIsBeingEdited.publicationDate"
          ></nx-form-date-time-picker>
          <nx-taxonomy-form-selector
            name="authorId"
            type="author"
            :label="$t('message.form.fields.author')"
            :value="messageThatIsBeingEdited.authorId"
            :limit="1">
          </nx-taxonomy-form-selector>
          <nx-message-body-editor
            name="body"
            type="advanced"
            :label="$t('message.form.fields.body')"
            :value="messageThatIsBeingEdited.body"
            :options="editorOptions"
            :hint="$t('message.content.live.bodyHint')"
          ></nx-message-body-editor>
        </form>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import moment from 'moment';
import { mapGetters, mapState } from 'vuex';
import Form from '@/modules/form/Form';
import NxFormSwitch from '@/modules/form/components/FormSwitch';
import NxDateTimePicker from '@/modules/form/components/FormDateTimePicker';
import NxTaxonomyFormSelector from '@/modules/taxonomy/selector/FormSelector';
import editorOptions from '@/components/texteditor/config/advanced';
import MessageBodyEditor from '@/modules/live-messages/form/MessageBodyEditor';

export default {
  name: 'nx-live-messages-form',
  extends: Form,
  components: {
    [NxFormSwitch.name]: NxFormSwitch,
    [NxDateTimePicker.name]: NxDateTimePicker,
    [MessageBodyEditor.name]: MessageBodyEditor,
    [NxTaxonomyFormSelector.name]: NxTaxonomyFormSelector,
  },
  methods: {
    updateField(field, value) {
      this.$store.dispatch('live/SET_MESSAGE_THAT_IS_BEING_EDITED_VALUE_BY_ATTRIBUTE', [field, value]);
      this.$store.dispatch('live/SET_FORM', this.form);
    },
  },
  computed: {
    ...mapGetters('live', [
      'messageTypes',
    ]),
    ...mapState('live', [
      'messageThatIsBeingEdited',
    ]),
    editorOptions() {
      const options = Object.assign({}, editorOptions.sidebar);
      // Eliminamos la opción de insertar un Minuto a Minuto
      delete options['ql-live'];
      return options;
    },
    maxDate() {
      return moment().toISOString();
    },
  },
};
</script>
<style>
.message-form .message-form__type--select i.v-icon.fa {
  font-size: 24px;
  font-weight: 400;
  font-style: normal;
}

.message-form__type--data {
  margin-bottom: 20px;
}

.message-form__toolbar .v-toolbar__content {
  padding: 0;
  text-transform: uppercase;
  color: #a0a0ad;
}
</style>
